import * as React from "react";
import { SingleNavMenuLinkButton as ISingleNavMenuLinkButton } from "../../../pages/identity/useNavMenu";
import { Button } from "antd";

interface Props {
  link: ISingleNavMenuLinkButton;
  index: number;
}
export const SingleNavMenuLinkButton: React.FC<Props> = ({ link, index }) => {
  return (
    // TODO update correctly this htmlType type
    <div className="px-4" key={link.label}>
      <Button //
        className={`my-1 ${link.className || ""}`}
        onClick={
          link.onClick
            ? (e) => {
                if (link.htmlType === "submit") {
                  e.preventDefault();
                }
                link.onClick();
              }
            : undefined
        }
        onMouseDown={
          link.onMouseDown
            ? (e) => {
                e.preventDefault();
                link.onMouseDown(e);
              }
            : undefined
        }
        htmlType={link.htmlType || "button"}
        block
        danger={link.danger}
        loading={link.loading}
        // TODO also update this type to use from ant types
        type={link.type as any}
        disabled={link.disabled}
      >
        {link.label}
      </Button>
    </div>
  );
};
